import fetcher from 'api/fetcher';

import { setExistAdvertisingCampaigns } from 'store/autoReducers';
import { AppThunkAction } from 'store/utils';

interface ExistAdvertisingCampaignsData {
    existAdvertisingCampaigns: boolean;
}

export const fetchExistAdvCampaigns = (): AppThunkAction => {
    return (dispatch) => {
        return fetcher
            .get<unknown, ExistAdvertisingCampaignsData>('/api/v1/campaigns/exist_advertising_campaigns')
            .then(({ existAdvertisingCampaigns }) => {
                dispatch(setExistAdvertisingCampaigns(existAdvertisingCampaigns));
            });
    };
};
